import { FormGroup, FormControl } from '@angular/forms';
import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform, ChangeDetectionStrategy } from '@angular/core';
import { } from 'rxjs/Rx';
import { NotificationServices } from '../services/notification_services';
import { UserTO, NotificationTO, ResultMessage, CommaonUserTO } from '../model/notificationTO'
import { Router, ActivatedRoute } from '@angular/router';
//import { ListService, ILoader } from "../../common/service/getDropdownList.service";


@Component({
    selector: 'notification',
    templateUrl: '../notification.html',

})

export class NotificationComponent implements OnInit {
    userTO: CommaonUserTO = {};
    @Input() URL: string;
    resultMessage: ResultMessage = new ResultMessage;
    constructor(
        private comman: NotificationServices
        , private router: Router
        , route: ActivatedRoute
    ) {
        this.userTO = this.comman.getUserTOFromLocalStorage();
    }
    notificationList: NotificationTO[] = [];
    ngOnInit() {
        this.comman.getAlertForNotify(this.URL);
        this.getNotificationListByUser();
    }

    getNotificationListByUser() {
        this.notificationList = []
        this.comman.getAllActiveNotification(this.userTO, this.URL).subscribe(
            notificationRes => {
                this.notificationList = notificationRes;
            },
            err => {
                console.log('Err : ' + err);

            }
        )
    }

    markAsReadToNotification(alertMessageTo: NotificationTO, isReset: boolean = false) {
        debugger
        if (alertMessageTo.IsAcknowledged != 0 && !isReset) {
            return;
        }
        if (isReset) {
            alertMessageTo.IsReseted = 1;
        }
        this.comman.postAlertAcknowledgement(alertMessageTo, this.userTO.IdUser, this.URL).subscribe(
            vRes => {
                debugger
                // if (this.resultMessage.MessageType == 1 && this.resultMessage.Result == 1) {

                this.comman.getAlertForNotify(this.URL);
                this.getNotificationListByUser();
                //}
            },
            err => {
                console.log("Error Msg : " + err);
            }
        )

    }

    getValidationColor(isAcknowelded: number) {
        return isAcknowelded == 0 ? 'bold' : 'normal'

    }
    resetAllNotification() {
        //this.ss.showLoader();
        this.comman.postAllAlertAcknowledgement(this.userTO, this.URL).subscribe(
            vRes => {
                //this.resultMessage = vRes;
                if (this.resultMessage.MessageType == 1 && this.resultMessage.Result == 1) {
                    this.comman.getAlertForNotify(this.URL);
                    this.notificationList = [];
                }
            },
            err => {
                console.log("Error Msg : " + err);
            }

        )
    }

    redirectFun(alertMessageTo: NotificationTO) {
        if (alertMessageTo.NavigationUrl != null || alertMessageTo.NavigationUrl != "") {
            this.router.navigate(['/' + alertMessageTo.NavigationUrl]);
        }


    }
}